"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = App;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _store = _interopRequireDefault(require("./store"));
/* global window */


function App(props) {
  var modules = props.modules,
      _props$appSpecificMod = props.appSpecificModules,
      appSpecificModules = _props$appSpecificMod === void 0 ? {} : _props$appSpecificMod,
      children = props.children,
      other = (0, _objectWithoutProperties2["default"])(props, ["modules", "appSpecificModules", "children"]);
  return _react["default"].createElement(_reactRedux.Provider, (0, _extends2["default"])({
    store: (0, _store["default"])(modules, appSpecificModules)
  }, other), children);
}